import { render, staticRenderFns } from "./AllocatedCounts.vue?vue&type=template&id=3c24f0c1"
import script from "./AllocatedCounts.vue?vue&type=script&lang=js"
export * from "./AllocatedCounts.vue?vue&type=script&lang=js"
import style0 from "./AllocatedCounts.vue?vue&type=style&index=0&id=3c24f0c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports